import React from "react";
import { NavLink } from "react-router-dom";

const Navigation: React.FC = () => {
  return (
    <nav className="bg-gray-800 bg-opacity-60 backdrop-blur-[3px] p-4 z-10 text-white sticky top-0 overflow-hidden">
      <div className="container flex px-8">
        <NavLink
          to="/"
          aria-label="PWC Profiles - Home"
          className="text-white hover:text-blue-400 text-lg font-bold"
        >
          <svg
            width="100"
            height="32"
            viewBox="0 0 161.28018 48"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="currentColor"
              d="M 0,0 19.199706,48 H 35.52012 L 27.840534,28.800295 H 49.919529 L 38.39941,0 Z M 54.719825,0 64.320414,23.999999 73.919529,0 Z M 87.360652,0 96.959766,23.999999 106.56035,0 Z m 35.520118,0 -19.20118,48 h 38.40088 l 5.76007,-14.39941 h -22.08047 l 7.68398,-19.20118 h 22.07607 L 161.28018,0 Z M 80.640838,23.999999 71.040236,48 h 19.199693 z"
            />
          </svg>
        </NavLink>
        <div className="container mx-auto flex justify-between items-center w-full px-8">
          <ul className="flex space-x-8 text-right">
            <li className="whitespace-nowrap overflow-ellipsis">
              <NavLink
                to="/kemper"
                className={
                  ({ isActive }) =>
                    isActive
                      ? "text-blue-400"
                      : "text-white hover:text-blue-400" // Added hover effect
                }
              >
                <span className="block sm:hidden">Kemper </span>
                <span className="hidden sm:block">Kemper Profiles</span>
              </NavLink>
            </li>

            <li className="whitespace-nowrap overflow-ellipsis">
              <NavLink
                to="/tonex"
                className={
                  ({ isActive }) =>
                    isActive
                      ? "text-blue-400"
                      : "text-white hover:text-blue-400" // Added hover effect
                }
              >
                <span className="block sm:hidden">Tonex </span>
                <span className="hidden sm:block">Tonex Models</span>
              </NavLink>
            </li>
            <li className="whitespace-nowrap overflow-ellipsis">
              <NavLink
                to="/nam"
                className={
                  ({ isActive }) =>
                    isActive
                      ? "text-blue-400"
                      : "text-white hover:text-blue-400" // Added hover effect
                }
              >
                <span className="block sm:hidden">NAM </span>
                <span className="hidden sm:block">Neural Amp Modeler</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
